import React from 'react';
import { MapEditorCanvas } from '../MapCanvas/MapEditorCanvas';
import { useMapCanvasStage, useMapCanvasStagePosition } from '../contexts/MapCanvasContext';
import {MapEditorContextMenu}  from './context-menu/MapEditorContextMenu';

export const EditorCanvas: React.FC = () => {
  const { stagePosition } = useMapCanvasStagePosition();
  const { updateStagePosition } = useMapCanvasStage();

  return (
    <div className="map-editor-container absolute inset-0 z-0" data-allow-zoom>
      <MapEditorContextMenu>
        <MapEditorCanvas
          stagePosition={stagePosition}
          onStageChange={updateStagePosition}
        />
      </MapEditorContextMenu>
    </div>
  );
};
